import { IFormation } from '@shared';

export const PRIVATE_LESSON_DEDUCTION_HOURS = 10;
export const TRAINING_DURATION_VARIATION = 0.1;
export const DUPLICATE_COURSE_IDS_WARNING = "Des cours d'un même module partagent le même identifiant : la progression des apprenants est commune à ces cours.\n\nPour les séparer, supprimez puis recréez un des cours concernés (il obtiendra un nouvel identifiant, sa validation sera remise à zéro pour les apprenants).\n\nConfirmez pour sauvegarder quand même.";
export const COPIED_FEEDBACK_DURATION_MS = 3000;
export const DELIVERABLE_PROMPT_INTRO_PREFIX = "Tu génères un livrable professionnel pour un apprenant en formation";
export const DELIVERABLE_PROMPT_SLIDE_PREFIX = 'SLIDE';
export const DELIVERABLE_PROMPT_TITLE_PREFIX = 'Titre :';
export const DELIVERABLE_PROMPT_SLIDE_SEPARATOR = '---';
export const DELIVERABLE_PROMPT_LABEL_TRAILING_PUNCTUATION = /[\s?:.]+$/;
export const DELIVERABLE_VARIABLES_EMPTY_HINT = "Aucune question de livrable dans cette formation : ajoutez des questions dans les cours, leurs variables apparaitront ici.";
export const NO_FORMATIONS: IFormation[] = [];
export const YOUTUBE_VIDEO_ID_PATTERN = /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:embed\/|shorts\/|live\/|v\/|watch\?(?:[^#]*&)?v=))([\w-]{11})(?![\w-])/;
export const YOUTUBE_EMBED_BASE_URL = 'https://www.youtube-nocookie.com/embed/';
export const YOUTUBE_EMBED_DEFAULT_QUERY = '?rel=0';
